"use strict";
/**
 * @module React button components
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackButton = exports.Button = exports.ButtonLink = void 0;
var React = require("react");
function ButtonLink(_a) {
    var _b = _a.name, name = _b === void 0 ? "" : _b, _c = _a.content, content = _c === void 0 ? "" : _c, _d = _a.modifierClass, modifierClass = _d === void 0 ? "" : _d, _e = _a.onClick, onClick = _e === void 0 ? null : _e;
    return (React.createElement("button", { name: name, onClick: onClick, className: "btn vx_btn-link " + modifierClass }, content));
}
exports.ButtonLink = ButtonLink;
function Button(_a) {
    var _b = _a.href, href = _b === void 0 ? "" : _b, _c = _a.target, target = _c === void 0 ? "" : _c, _d = _a.name, name = _d === void 0 ? "" : _d, _e = _a.type, type = _e === void 0 ? "button" : _e, _f = _a.content, content = _f === void 0 ? "" : _f, _g = _a.modifierClass, modifierClass = _g === void 0 ? "" : _g, _h = _a.isSecondary, isSecondary = _h === void 0 ? false : _h, _j = _a.disabled, disabled = _j === void 0 ? false : _j, _k = _a.isSecondaryReversed, isSecondaryReversed = _k === void 0 ? false : _k, _l = _a.onClick, onClick = _l === void 0 ? null : _l;
    var classNames = "btn vx_btn " + modifierClass + (isSecondary ? " vx_btn-secondary" : "") +
        ("" + (isSecondaryReversed ? " vx_btn-secondary_reversed" : ""));
    if (href) {
        return (React.createElement("a", { href: href, type: type, target: target, className: classNames }, content));
    }
    return (React.createElement("button", { type: type, disabled: disabled, name: name, onClick: onClick, className: classNames }, content));
}
exports.Button = Button;
function BackButton(_a) {
    var _b = _a.href, href = _b === void 0 ? "" : _b, _c = _a.modifierClass, modifierClass = _c === void 0 ? "" : _c, _d = _a.name, name = _d === void 0 ? "" : _d, _e = _a.content, content = _e === void 0 ? "" : _e;
    var classNames = "vx_backBtn " + modifierClass;
    if (href !== undefined) {
        return (React.createElement("a", { href: href, className: classNames }, content));
    }
    return (React.createElement("button", { name: name, className: classNames }, content));
}
exports.BackButton = BackButton;
